import React, { Component, useEffect, useState } from "react";
import * as stdActions from "../../redux/actions/stdAction";
import Pagination from "../Std/Pagination";
import * as utilities from "../../utilities/utils";
import moment from "moment";
import DropdownComponent from "../../containers/Dropdown";
import { ATTACHMENT_FILTER, ATTACHMENT_FILTER_FR, PAGE_SIZE_DRP } from "../../App.config";
import DownloadSvg from "../../images/download.svg";
import Backbutton from "../../containers/Common/Backbutton";
import DisplayEmployeeName from "../../containers/DisplayEmployeeName";

const AttachmentsComponent = (props, context) => {
  const onDropDownChange = (event) => {
    let { name, value } = event;

    if (value.length) {
      props.onPageSizeChange(
        utilities.extractFirstValueOfArray(value),
        props.ein
      );
    }
  };

  const attachmentFilterByLang = () => {
    let defaultLang = ATTACHMENT_FILTER;
    if (props.i18nReducer.lang === "en-US") {
      defaultLang = ATTACHMENT_FILTER;
    } else {
      defaultLang = ATTACHMENT_FILTER_FR;
    }

    return defaultLang;
  };

  const onAttachmentDropDownChange = (event) => {
    let { name, value } = event;

    if (value.length) {
      if (utilities.extractFirstValueOfArray(value)) {
        props.customAttachment(props.ein);
      } else if (utilities.extractFirstValueOfArray(value) === null) {
        props.otherAttachment(props.ein);
      } else {
        props.formAttachment(props.ein);
      }
    }
  };

  const onChange = (event) => {
    props.onChange({ name: event.target.name, value: event.target.value });
  };

  const handleAllDownload = () => {
    props.downloadAllAttachments(props.ein, props.isCustomAttachment);
  };

  return (
    <>
      <div className="Dashboard-Content">
        <div className="row">
          <div className="back-btn-outer">
            <Backbutton />
          </div>
        </div>
        {/* <div className="Inner-cell">
          <div className="Panel-cell">
            <div className="Card-panel padding-20">
              <div className="row">
                <div className="col-12 col-sm-12 col-md-12 col-lg-4">
                  <div className="form-group">
                    <label htmlFor="">Search by EIN</label>
                    <input
                      type="text"
                      name="ein"
                      value={state.ein.value}
                      onChange={handleChanges}
                      placeholder="Search by EIN"
                      className="form-control"
                    />
                    {state.ein?.error && (
                      <span className="error">{state.ein.error}</span>
                    )}
                  </div>
                </div>
                <div className="col-12 col-sm-12 col-md-12 col-lg-3">
                  <div className="form-group">
                    <label htmlFor=""></label>
                    <button
                      onClick={() => props.customAttachment(state.ein.value)}
                      className="btn btn-primary margin-top-30"
                    >
                      Custom Attachments
                    </button>
                  </div>
                </div>
                <div className="col-12 col-sm-12 col-md-12 col-lg-4">
                  <div className="form-group">
                    <label htmlFor=""></label>
                    <button
                      onClick={() => props.formAttachment(state.ein.value)}
                      className="btn btn-primary margin-top-30"
                    >
                      Form Attachments
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> */}

        <div className="Inner-cell">
          <DisplayEmployeeName context={props.context}/>
          <div className="Panel-cell">
            <div className="Card-panel">
              <div className="table-header">
                <p>
                  {props.isCustomAttachment
                    ? props.context.t("Attachment.CurrentlyShowingAttachment.Text")
                    : props.isCustomAttachment === null
                      ? props.context.t("Attachment.CurrentlyShowingAllDocs.Text")
                      : props.context.t("Attachment.CurrentlyShowingSubmission.Text")}
                </p>
                <div className="pagesize-dropdown">
                  <DropdownComponent
                    name="pageSize"
                    options={PAGE_SIZE_DRP}
                    isMultiSelect={false}
                    option_key="pageSize"
                    option_display="pageSizeValue"
                    onChange={onDropDownChange}
                    values={[props.pageSize]}
                    simplePlaceholder="STD-Employer-Statement.form.dropdown.PlaceHolder.Common.SelectOptions"
                    selectAllText="Select All Options"
                    isSearchOption={false}
                  />
                </div>
                {props.formType === "std" ? (
                  <div className="filter-drp">
                    <DropdownComponent
                      name="custom-filter"
                      options={attachmentFilterByLang()}
                      isMultiSelect={false}
                      option_key="ID"
                      option_display="Value"
                      onChange={onAttachmentDropDownChange}
                      values={[props.isCustomAttachment]}
                      simplePlaceholder="STD-Employer-Statement.form.dropdown.PlaceHolder.Common.SelectOptions"
                      selectAllText="Select All Options"
                      isSearchOption={false}
                    />
                  </div>
                ) : null}
              </div>
              <div className="table-header-2">
                {Array.isArray(props.attachmentData) &&
                  props.attachmentData.length ? (
                  <div className="download-btn">
                    <span onClick={handleAllDownload}>{props.context.t("Attachment.DownloadAll.Text")}</span>
                  </div>
                ) : (
                  <div className="download-btn disabled">
                    <span>{props.context.t("Attachment.DownloadAll.Text")}</span>
                  </div>
                )}
              </div>
              <div className="Table-list">
                <div className="Table-head">
                  <div className="Table-cell">
                    <table className="table table-striped">
                      <thead>
                        <tr>
                          <th>{props.context.t("Attachment.Id.Text")}</th>
                          <th>{props.context.t("Attachment.FileName.Text")}</th>
                          <th>{props.context.t("Attachment.FileDesc.Text")}</th>
                          <th>{props.context.t("Attachment.FileSize.Text")}</th>
                          <th>{props.context.t("Attachment.CreatedOnDate.Text")}</th>
                          <th>{props.context.t("Attachment.Type.Text")}</th>
                          <th>{props.context.t("Attachment.FileType.Text")}</th>
                        </tr>
                      </thead>
                      <tbody>
                        {Array.isArray(props.attachmentData) &&
                          props.attachmentData.length ? (
                          props.attachmentData.map((attachment, index) => (
                            <tr key={`attachment-${index}`}>
                              <td>{++index}</td>
                              <td
                                data-toggle="tooltip"
                                data-placement="top"
                                title={
                                  attachment.filename
                                    ? attachment.filename
                                    : null
                                }
                              >
                                {attachment.filename
                                  ? utilities.validFileName(
                                    attachment.filename,
                                    25
                                  )
                                  : "-"}
                              </td>
                              <td>
                                {attachment.desc
                                  ? attachment.desc
                                  : "-"}
                              </td>
                              <td>
                                {attachment.fileLength
                                  ? attachment.fileLength
                                  : "-"}
                              </td>
                              <td>
                                {attachment.createdOnDate ? moment(attachment.createdOnDate).format("MMM DD YYYY") : "-"}
                              </td>
                              <td>
                                <span
                                  className={"badge " + (attachment.attachemntType == "STD" ? "badge-warning"
                                    : attachment.attachemntType == "ACMD" ? "badge-success" : "badge-info")
                                  }
                                >
                                  {attachment.attachemntType || "-"}
                                </span>
                              </td>
                              <td>
                                <span
                                  onClick={() =>
                                    utilities.download(attachment.fullPdfPath)
                                  }
                                  className="status-label label-Cashout"
                                >
                                  {attachment.fileType
                                    ? utilities.extractFileType(
                                      attachment.fileType
                                    )
                                    : ""}
                                </span>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="5" className="table-no-data-text">
                              No attachments found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
                <div className="table-footer">
                  <span htmlFor="">{props.context.t("Attachment.TotalRows.Text")}: {props.totalRows}</span>

                  <Pagination
                    currentPage={props.currentPage}
                    pageSize={props.pageSize}
                    totalRows={props.totalRows}
                    onClickPre={(pageNo) => {
                      onChange({
                        target: {
                          name: "currentPage",
                          value: pageNo,
                        },
                      });
                      utilities.scrollToTop();
                    }}
                    onClickNext={(pageNo) => {
                      onChange({
                        target: {
                          name: "currentPage",
                          value: pageNo,
                        },
                      });
                      utilities.scrollToTop();
                    }}
                    onClickPage={(pageNo) => {
                      onChange({
                        target: {
                          name: "currentPage",
                          value: pageNo,
                        },
                      });
                      utilities.scrollToTop();
                    }}
                  ></Pagination>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AttachmentsComponent;
